import { AddPlants } from './AddPlants'
import { BulkGift } from './BulkGift'
import { Co2 } from './Co2'
import { CrowdFund } from './CrowdFund'
import { DefaultAvatar } from './DefaultAvatar'
import { Expand } from './Expand'
import { Gift } from './Gift'
import { GiftBox } from './GiftBox'
import { LandSize } from './LandSize'
import { Monthly } from './Monthly'
import { OneOff } from './OneOff'
import { Seedling } from './Seedling'
import { Spade } from './Spade'
import { SupportedProjects } from './SupportedProjects'
import { TallArrowLeft } from './TallArrowLeft'
import { TallArrowRight } from './TallArrowRight'
import { Tick } from './Tick'
import { TreePlanting } from './TreePlanting'

export { AddPlants } from './AddPlants'
export { BulkGift } from './BulkGift'
export { Co2 } from './Co2'
export { CrowdFund } from './CrowdFund'
export { DefaultAvatar } from './DefaultAvatar'
export { Expand } from './Expand'
export { Gift } from './Gift'
export { GiftBox } from './GiftBox'
export { LandSize } from './LandSize'
export { Monthly } from './Monthly'
export { OneOff } from './OneOff'
export { Seedling } from './Seedling'
export { Spade } from './Spade'
export { SupportedProjects } from './SupportedProjects'
export { TallArrowLeft } from './TallArrowLeft'
export { TallArrowRight } from './TallArrowRight'
export { Tick } from './Tick'
export { TreePlanting } from './TreePlanting'

export const Icons = {
  AddPlants,
  BulkGift,
  Co2,
  CrowdFund,
  DefaultAvatar,
  Expand,
  Gift,
  GiftBox,
  LandSize,
  Monthly,
  OneOff,
  Seedling,
  Spade,
  SupportedProjects,
  TallArrowLeft,
  TallArrowRight,
  Tick,
  TreePlanting
}
